<template>
  <ul class="vx-timeline">
      <li v-for="item in _timelineData" :key="item.id">
          <div class="timeline-icon" :class="`bg-${item.color}`">
              <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
          </div>
          <div class="timeline-info">
              <div class="button-container">
                <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                  <vs-button class="p-5 m-0" color="primary" type="relief" icon-pack="feather" icon="icon-eye" @click="view(item)" v-if="visibilityView(item)"></vs-button>
                  <vs-button class="p-5 ml-1" color="danger" type="relief" icon-pack="feather" icon="icon-trash" @click="del(item.id);" v-if="visibilityDel(item)"></vs-button>
                </div>
              </div>
              <p class="font-semi-bold">{{item.seq}}. {{ item.title }}</p>
              <span class="activity-desc">{{ item.desc !== '' ? item.desc : "-" }}</span>
          </div>
        <div class="flex-container">
          <small class="text-grey activity-e-time">วันที่ {{ item.date | convYYYYMMDDToDDMMYYYY }}</small>
          <small class="text-grey activity-e-time">วันที่บันทึก {{ item.createdAtLocal }} โดย {{ item.createdBy }}</small>
        </div>
      </li>
  </ul>
</template>

<script>
import {createNamespacedHelpers} from "vuex";

const {mapActions: mapProsecutionActions, mapState: mapProsecutionState} = createNamespacedHelpers('Prosecution');
export default {
  name: 'prosecution-timeline',
  props: {
    timelineData: {
      type: Array,
    },
  },
  computed: {
    ...mapProsecutionState(['disabledCaseStatusOptions', 'endCaseStatus', 'prosecution']),
    currentUser () {
      if(!this.$store.state.currentUser){
        return null
      }
      return {
        id: this.$store.state.currentUser.id,
        email: this.$store.state.currentUser.email,
        role: this.$store.state.currentUser.role
      }
    },
    isRoot(){
      if(!this.currentUser){
        return false
      }
      const { isRoot } = this.currentUser.role
      return isRoot
    },
    isLawyer(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === 'lawyer'
    },
    isLegalCounsel(){
      if(!this.currentUser){
        return false
      }
      return this.currentUser.role.type === 'legalCounsel'
    },
    contractId(){
      if(!this.prosecution.contract) return null;
      return this.prosecution.contract.id;
    },
    prosecutionId(){
      return this.prosecution.id;
    },
    prosecutionType(){
      if(!this.prosecution.contract) return false;
      return this.prosecution.prosecutionType;
    },
    _timelineData(){
      return this.timelineData
        .slice() // Create a shallow copy to avoid modifying the original data
        .sort((a, b) => {
          const dateComparison = new Date(a.date) - new Date(b.date);
          if (dateComparison !== 0) {
            return dateComparison;
          }
          return new Date(a.createdAt) - new Date(b.createdAt);
        })
        .map((item, index) => {
        return {
          ...item,
          seq: index + 1,
          color: item.caseStatus === 'success' ? 'success' : item.caseStatus === 'danger' ? 'danger' : 'warning',
          icon: item.caseStatus === 'success' ? 'CheckCircleIcon' : item.caseStatus === 'danger' ? 'AlertCircleIcon' : 'ClockIcon',
          createdAtLocal: item.createdAtLocal,
        }
      })
    }
  },
  methods: {
    ...mapProsecutionActions(['softDeleteProsecutionDetail']),
    visibilityView(row){
      const { lawyerEmail } = this.prosecution;
      const isLawyerAssign = (this.isLawyer || this.isLegalCounsel) && lawyerEmail === this.currentUser.email;
      const isDisabledCaseStatusOptions = this.disabledCaseStatusOptions.includes(row.caseStatus)
      const isEndCaseStatus = this.endCaseStatus.includes(this.prosecution.caseStatus)
      return !isDisabledCaseStatusOptions && !isEndCaseStatus && (this.isRoot || isLawyerAssign);
    },
    visibilityDel(row){
      const { lawyerEmail } = this.prosecution;
      const isLawyerAssign = (this.isLawyer || this.isLegalCounsel) && lawyerEmail === this.currentUser.email;
      const isDisabledCaseStatusOptions = this.disabledCaseStatusOptions.includes(row.caseStatus)
      const isEndCaseStatus = this.endCaseStatus.includes(this.prosecution.caseStatus)
      return !isDisabledCaseStatusOptions && !isEndCaseStatus && (this.isRoot || isLawyerAssign);
    },
    view(item) {
      this.$router.push({name: 'prosecution-transaction-view', params: {
          contractId: this.contractId,
          prosecutionId: this.prosecutionId,
          prosecutionDetailId: item.id,
          prosecutionType: this.prosecutionType
        }});
    },
    async del (id) {
      const vm = this;
      const { softDeleteProsecutionDetail } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: async () => {
          await softDeleteProsecutionDetail({
            form: {
              id
            },
            vm
          });
        }
      })
    },
  },
}
</script>

<style scoped>
.button-container {
   float: right;
}
.flex-container {
  display: flex;
  justify-content: space-between; /* This will align one to the left and one to the right */
  width: 100%;
}
</style>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
